import { render, staticRenderFns } from "./CorporativeAccountList.vue?vue&type=template&id=29c19e36"
import script from "./CorporativeAccountList.vue?vue&type=script&lang=js"
export * from "./CorporativeAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports